import { BUY_PRICE, MONTHLY_PRICE } from './values';

export default [
  {
    label: __('search.filters.priceTypeBuy'),
    value: BUY_PRICE,
  },
  {
    label: __('search.filters.priceTypeMonthly'),
    value: MONTHLY_PRICE,
  },
];
